export default {
  hsmName: {
    value: '',
    required: true,
    state: null
  },
  hsmId: {
    value: '',
    required: true,
    state: null
  },
  hsmText: {
    value: '',
    maxlength: '160',
    required: true,
    state: null,
    rows: 7,
    size: 500
  },
  provedor: {
    value: null,
    options: [
      {
        text: 'DIGITALK',
        value: 'DIGITALK'
      },
      {
        text: 'NXZAP',
        value: 'NXZAP'
      },
      {
        text: 'UBOTS',
        value: 'UBOTS'
      }
    ],
    required: false,
    state: null
  },
  buttonCTA: {
    value: false,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/hsm/components/add/hsm-form.js